export default from './BuyerSettings';



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/index.js